(function () {
  try {
    /* main variables */
    var debug = 0;
    var variation_name = "CC058: Compressed PDP";
    var variantion_class = "CC058-main";

    // Important Selector
    var selectors = {
      colorSelector:
        ".ProductForm__Option--labelled.productOption--finish, .ProductForm__Option.ProductForm__Option--labelled.productOption--necklace-2-finish, .ProductForm__Option.ProductForm__Option--labelled.productOption--necklace-1-finish, .ProductForm__Option--labelled.ProductForm__Option",
      waitForElementSelector:
        ".ProductForm__Option--labelled.productOption--finish input, .ProductForm__Option.ProductForm__Option--labelled.productOption--necklace-1-finish input, .ProductForm__Option.ProductForm__Option--labelled.productOption--necklace-2-finish input, .ProductForm__Option--labelled.ProductForm__Option input",
    };

    function debounce(func, delay) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
      };
    }

    function observeSelector(selector, callback, options = {}) {
      const document = options.document || window.document;
      const processed = new Map();

      if (options.timeout || options.onTimeout) {
        throw `observeSelector options \`timeout\` and \`onTimeout\` are not yet implemented.`;
      }

      let obs;
      let isDone = false;

      const done = () => {
        if (obs) obs.disconnect();
        isDone = true;
      };

      const processElement = (el) => {
        if (!processed.has(el)) {
          processed.set(el, true);
          callback(el);
          if (options.once) {
            done();
            return true;
          }
        }
        return false;
      };

      const lookForSelector = () => {
        const elParent = document.documentElement;
        if (elParent.matches(selector) || elParent.querySelector(selector)) {
          const elements = elParent.querySelectorAll(selector);
          elements.forEach((el) => processElement(el));
        }
      };

      const debouncedLookForSelector = debounce(() => {
        lookForSelector();
      }, 100);

      // Initial check for the selector on page load
      lookForSelector();

      if (!isDone) {
        obs = new MutationObserver(() => {
          debouncedLookForSelector();
        });

        obs.observe(document, {
          attributes: false,
          childList: true,
          subtree: true,
        });
      }

      return done;
    }

    // Wait for element
    function waitForElement(selector, trigger) {
      var interval = setInterval(function () {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
          clearInterval(interval);
          trigger();
        }
      }, 50);
      setTimeout(function () {
        clearInterval(interval);
      }, 15000);
    }

    // Live click
    function live(selector, event, callback, context) {
      // helper for enabling IE 8 event bindings
      function addEvent(el, type, handler) {
        if (el.attachEvent) el.attachEvent("on" + type, handler);
        else el.addEventListener(type, handler);
      }
      // matches polyfill
      this.Element &&
        (function (ElementPrototype) {
          ElementPrototype.matches =
            ElementPrototype.matches ||
            ElementPrototype.matchesSelector ||
            ElementPrototype.webkitMatchesSelector ||
            ElementPrototype.msMatchesSelector ||
            function (selector) {
              var node = this,
                nodes = (node.parentNode || node.document).querySelectorAll(selector),
                i = -1;
              while (nodes[++i] && nodes[i] != node);
              return !!nodes[i];
            };
        })(Element.prototype);
      // live binding helper using matchesSelector
      function live(selector, event, callback, context) {
        addEvent(context || document, event, function (e) {
          var found,
            el = e.target || e.srcElement;
          while (el && el.matches && el !== context && !(found = el.matches(selector))) el = el.parentElement;
          if (found) callback.call(el, e);
        });
      }
      live(selector, event, callback, context);
    }

    // Change content
    function changeContent(selector, content) {
      var el = document.querySelector(selector);
      if (el) {
        el.innerHTML = content;
      }
    }

    // https://www.customcuff.co/products/custom-necklace?al_pg_id=380dc97b-ee12-41f8-b111-99da547b47c8
    var productGalleryImages = [
      {
        img: "https://www.customcuff.co/cdn/shop/products/SilverbarNecklace.jpg",
        mediaId: "20699810365501",
        imagePosition: 5,
        productURL: "/products/custom-necklace",
      },
      {
        img: "https://www.customcuff.co/cdn/shop/products/silvercustomcoordinateschainbraceletcc.jpg",
        mediaId: "20400674832445",
        imagePosition: 5,
        productURL: "/products/infinity-chain-bracelet",
      },
    ];

    /**
     * =================================================================
     * New PDP color options
     * =================================================================
     */
    function addMaterialSelectorOnPDP() {
      var finishDiv = document.querySelectorAll('div[data-option-name*="FINISH"]');
      if (finishDiv) {
        finishDiv.forEach(function (finish) {
          finish.style.display = "block";
          finish.classList.add("custColor");

          if (finishDiv.length > 1) {
            finish.classList.add("custColorMultiple");
          }
        });
      }

      var labelOfColorElement = document.querySelectorAll(".custColor .ProductForm__Label, .custColor .ProductForm__Label");
      if (labelOfColorElement) {
        labelOfColorElement.forEach(function (label, i) {
          if (labelOfColorElement.length == 1) {
            label.textContent = "Select finish:";
          } else {
            if (i == 0) {
              label.textContent = "select necklace 1 finish:";
            } else {
              label.textContent = "select necklace 2 finish:";
            }
          }
        });
      }

      var colorOptionsArray = {
        GOLD: { colorName: "Shiny Gold", imgSrc: "https://growth-hit.s3.us-west-2.amazonaws.com/custom-cuff/gold.png" },
        ROSE: { colorName: "Shiny rose", imgSrc: "https://growth-hit.s3.us-west-2.amazonaws.com/custom-cuff/rose_gold.png" },
        "MATTE BLACK": { colorName: "Matte black", imgSrc: "https://growth-hit.s3.us-west-2.amazonaws.com/custom-cuff/matte_black.png" },
        SILVER: { colorName: "Shiny silver", imgSrc: "https://growth-hit.s3.us-west-2.amazonaws.com/custom-cuff/steel_silver.png" },
        AURORA: { colorName: "18K Gold Aurora Finish", imgSrc: "https://growth-hit.s3.us-west-2.amazonaws.com/custom-cuff/arora_gold.png" },
        "SHINY GOLD": { colorName: "Shiny Gold", imgSrc: "https://growth-hit.s3.us-west-2.amazonaws.com/custom-cuff/gold.png" },
        "SHINY ROSE": { colorName: "Shiny rose", imgSrc: "https://growth-hit.s3.us-west-2.amazonaws.com/custom-cuff/rose_gold.png" },
        "SHINY SILVER": { colorName: "Shiny silver", imgSrc: "https://growth-hit.s3.us-west-2.amazonaws.com/custom-cuff/steel_silver.png" },
      };

      var liElements = document.querySelectorAll(".custColor li");
      Array.prototype.forEach.call(liElements, function (li) {
        var label = li.querySelector("label");
        if (label) {
          var optionValue = label.textContent.trim();
          var colorOptionData = colorOptionsArray[optionValue];
          var custClassName = `cust${optionValue.replace(/\s+/g, "")}`;

          if (colorOptionData && !label.querySelector(`.${custClassName}`)) {
            var colorBoxHtml = `
                <div class="custColorBox ${custClassName}">
                    <div class="colorImg">
                        <img src="${colorOptionData.imgSrc}" alt="${colorOptionData.colorName}">
                    </div>
                    <div class="colorName">${colorOptionData.colorName}</div>
                </div>`;
            label.insertAdjacentHTML("beforeend", colorBoxHtml);
          }
        }
      });

      // Click operations
      clickOperation();
    }

    function clickOperation() {
      var colorOptions = document.querySelectorAll(".custColor .productOption--finish input");
      Array.prototype.forEach.call(colorOptions, function (button) {
        button.addEventListener("click", function () {
          var colorNameElement = document.querySelector(".CC58-sticky-bar .product_variant");
          if (colorNameElement) {
            // colorNameElement.textContent = 'loading...';
            var labelElement = button.nextElementSibling;
            if (labelElement) {
              var colorLabelText = labelElement.childNodes[0] && labelElement.childNodes[0].nodeValue ? labelElement.childNodes[0].nodeValue.trim() : "";
              colorNameElement.textContent = colorLabelText;
            } else {
              colorNameElement.textContent = "";
            }
          }
        });
      });
    }

    // Change Evergraving type
    function changeEvergravingType() {
      var egTypes = document.querySelectorAll(".ProductForm__Variants .SizeSwatchList li input");
      var yesCopy = `
          <div class="cc58-product__evergraving--container  cc58-product__evergraving--option2">
            <span class="cc58-product__evergraving">
              <b>Without stone</b>
            </span>
          </div>`,
        noCopy = `
          <div class="cc58-product__evergraving--container  cc58-product__evergraving--option1">
            <span class="cc58-product__evergraving">
              <b>Moissanite stones</b>
              <span>Lab-grown diamond</span>
            </span>
          </div>`;

      egTypes.forEach(function (egType) {
        var value = egType.value;
        var label = egType.nextElementSibling;
        if (value === "YES") {
          label.innerHTML = noCopy;
        } else if (value === "NO") {
          label.innerHTML = yesCopy;
        }
      });
    }

    // Update second feature image
    function updateSecondFeatureImage(featured_media) {
      var galleryBox = document.querySelector(".cc58-Product__Slideshow");
      var allGalleryImages = document.querySelectorAll(".cc58-Product__Slideshow .cc58-Product__SlideItem--image");
      if (!galleryBox) return;

      if (!featured_media) return;

      var featureImage = featured_media.preview_image?.src,
        featureImageId = featured_media.id;

      // Inser new feature media image
      var newImageInsert = `
        <div tabindex="0" class="cc58-Product__SlideItem--image cc58-Product__SlideItem--imgfeature" data-gh-media-type="image">
          <div class="AspectRatio AspectRatio--withFallback" style="padding-bottom: 124.62562396006656%; --aspect-ratio: 1;">
            <img width="500" height="300" decoding="async" loading="lazy" class="Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[200,400,600]" data-sizes="auto" data-expand="-100" alt="Custom Cuff" data-max-width="601" data-max-height="749" data-original-src="${featureImage}" srcset="${featureImage}" src="${featureImage}" sizes="325px">
            <span class="Image__Loader"></span>
            <noscript><img width="500" height="300" decoding="async" loading="lazy" src="${featureImage}" alt="Custom Cuff"></noscript>
          </div>
        </div>`;

      // Feature image
      var featureImageElm = document.querySelector(".cc58-Product__SlideItem--imgfeature");
      if (!featureImageElm) {
        galleryBox.querySelectorAll(".cc58-Product__SlideItem--image")[0].insertAdjacentHTML("afterend", newImageInsert);
      } else if (featureImageElm) {
        var noScript = featureImageElm.querySelector("noscript");
        if (noScript) {
          noScript.innerHTML = `<img width="500" height="300" decoding="async" loading="lazy" src="${featureImage}" alt="Custom Cuff">`;
        }

        var img = featureImageElm.querySelector("img");
        setTimeout(function () {
          if (img) {
            img.src = img.dataset.srcset = img.dataset.originalSrc = img.srcset = featureImage;
          }
        }, 500);
      }

      // Update all feature image
      allGalleryImages?.forEach(function (image) {
        if (featureImageId == image.getAttribute("data-gh-media-id")) {
          image.setAttribute("data-hidden", "true");
        } else {
          image.removeAttribute("data-hidden");
        }
      });
    }

    // Change Gallery Image position
    function changeGalleryImagePosition() {
      var galleryBox = document.querySelector(".cc58-Product__Slideshow");
      var newImageInsert = `
        <div tabindex="0" class="cc58-Product__SlideItem--image cc58-Product__SlideItem--imagenew" data-gh-media-type="image" data-gh-media-id="2236234196799">
          <div class="AspectRatio AspectRatio--withFallback" style="padding-bottom: 124.62562396006656%; --aspect-ratio: 1;">
            <img width="500" height="300" decoding="async" loading="lazy" class="Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[200,400,600]" data-sizes="auto" data-expand="-100" alt="Custom Cuff" data-max-width="601" data-max-height="749" data-original-src="https://cdn.shopify.com/s/files/1/0026/0010/8078/files/choose-evgraving-img.png?v=1724336297" srcset="https://cdn.shopify.com/s/files/1/0026/0010/8078/files/choose-evgraving-img.png?v=1724336297" src="https://cdn.shopify.com/s/files/1/0026/0010/8078/files/choose-evgraving-img.png?v=1724336297" sizes="325px">
            <span class="Image__Loader"></span>
            <noscript><img width="500" height="300" decoding="async" loading="lazy" src="https://cdn.shopify.com/s/files/1/0026/0010/8078/files/choose-evgraving-img.png?v=1724336297" alt="Custom Cuff"></noscript>
          </div>
        </div>`;

      if (!galleryBox) return;
      var galleryBoxFourthSlide = galleryBox.querySelectorAll(".cc58-Product__SlideItem--image")[3];

      // Product Gallery Images
      productGalleryImages.forEach(function (image, i) {
        var galleryImage = document.querySelector(`.cc58-Product__SlideItem--image[data-gh-media-id="${image.mediaId}"]`);

        if (!galleryImage) return;

        // Insert new image
        if (!document.querySelector(".cc58-Product__SlideItem--imagenew")) {
          galleryBoxFourthSlide.insertAdjacentHTML("afterend", newImageInsert);
        }

        // Change image position if onlyImageChange is false
        if (!image.onlyImageChange) {
          galleryBoxFourthSlide.insertAdjacentElement("afterend", galleryImage);
        }
      });
    }

    // Show sticky footer on scroll
    function showStickyFooter() {
      var productAct = document.querySelector(".Product__InfoWrapper #Product__AddToCart, .Product__InfoWrapper .ProductForm__AddToCart");
      var isStickyBarAvailable = !!document.querySelector(".CC58-sticky-bar");
      if (productAct && isStickyBarAvailable) {
        var actFromTop = productAct.getBoundingClientRect().top;
        if (actFromTop < 100) {
          document.body.classList.add("cc58-sticky-bar--activate");
        } else {
          document.body.classList.remove("cc58-sticky-bar--activate");
        }
      }
    }

    // Function to ensure the active bullet is in the viewport
    function ensureActiveBulletInView() {
      var container = document.querySelector("body .Product__SlideshowMobileNav .flickity-page-dots");
      var activeBullet = container.querySelector(".dot.is-selected");

      if (activeBullet) {
        var containerRect = container.getBoundingClientRect();
        var bulletRect = activeBullet.getBoundingClientRect();

        if (bulletRect.left < containerRect.left) {
          // Scroll left to bring the bullet into view
          container.scrollLeft -= containerRect.left - bulletRect.left + bulletRect.width;
        } else if (bulletRect.right > containerRect.right) {
          // Scroll right to bring the bullet into view
          container.scrollLeft += bulletRect.right - containerRect.right + bulletRect.width;
        }
      }
    }

    // Custom Choose font select option
    function customSelectOption() {
      var selectHtml = `
          <div class="cc58-custom-select">
            <div class="cc58-custom-select__box" data-type="font-chooser-typewriter">
             <span class="cc58-engrave-font-sample">Aa</span>
             <span class="cc58-font-type-label">Typewriter</span>
            </div>
            <ul class="cc58-custom-select__options">
              <li class="cc58-custom-select__option" data-value="Typewriter" data-class="font-chooser-typewriter">Typewriter</li>
              <li class="cc58-custom-select__option" data-value="Handwriting" data-class="font-chooser-handwriter">Handwriting</li>
              <li class="cc58-custom-select__option" data-value="Old London" data-class="font-chooser-oldLondon">Old London</li>
              <li class="cc58-custom-select__option" data-value="Standard" data-class="font-chooser-standard">Standard</li>
            </ul>
          </div>`;

      var engraveSelectOpts = document.querySelectorAll(".engrave-font-chooser-wrapper .engrave-font-chooser-container");
      engraveSelectOpts?.forEach(function (evContainer) {
        var oldCustomSelectElm = evContainer.parentElement.querySelector(".cc58-custom-select");
        if (!oldCustomSelectElm) {
          evContainer.insertAdjacentHTML("beforebegin", selectHtml);
        }
      });
    }

    function addImageQuote() {
      var quoteHtml = `
          <div class="cc58-quote-box">
            <p>"We LOVE them and never take them off.
              <span>They don't tarnish or rust. It's beautiful."</span>
              <span class="cc58-quote__name"> - Kat B</span>
            </p>
          </div>`;

      if (!document.querySelector(".cc58-quote-box")) {
        document.querySelector(".Product__Slideshow .flickity-viewport").insertAdjacentHTML("afterend", quoteHtml);
      }
    }

    // Event Handler
    function eventHandlers() {
      window.addEventListener("scroll", showStickyFooter);

      // Observer to detect changes in the bullet list
      var container = document.querySelector("body .Product__SlideshowMobileNav .flickity-page-dots");
      var observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "class") {
            ensureActiveBulletInView();
          }
        });
      });

      // Ensure bullet in viewport
      ensureActiveBulletInView();

      // Observe each bullet for class changes
      var bullets = container?.querySelectorAll(".dot");
      bullets?.forEach((bullet) => {
        observer.observe(bullet, { attributes: true });
      });

      // Click on custom select option
      live(".cc58-custom-select__box", "click", function () {
        var optionsContainer = this.parentElement.querySelector(".cc58-custom-select__options");
        // Show container
        optionsContainer.style.display = optionsContainer.style.display === "block" ? "none" : "block";
      });

      // Click on custom select option
      live(".cc58-custom-select__options li", "click", function () {
        var parentBox = this.closest(".cc58-custom-select"),
          selectBox = parentBox.querySelector(".cc58-custom-select__box"),
          optionsList = parentBox.querySelectorAll(".cc58-custom-select__options li");
        var fontClass = this.getAttribute("data-class");
        var optionsContainer = parentBox.querySelector(".cc58-custom-select__options");
        var mainFontSelectBox = parentBox.nextElementSibling;

        selectBox.innerHTML = `
          <span class="cc58-engrave-font-sample">Aa</span>
          <span class="cc58-font-type-label">${this.textContent}</span>`;

        selectBox.setAttribute("data-value", this.getAttribute("data-value"));

        // Remove active class from all options
        optionsList.forEach((opt) => opt.classList.remove("active"));

        // Add active class to selected option
        this.classList.add("active");

        // select box data font class
        selectBox.setAttribute("data-type", fontClass);

        // Show container
        optionsContainer.style.display = "none";

        // Click on main box
        if (mainFontSelectBox) {
          mainFontSelectBox.querySelector(`.${fontClass}`)?.click();
        }
      });

      // Close the dropdown if clicked outside
      document.addEventListener("click", function (event) {
        var optionsContainers = document.querySelectorAll(".cc58-custom-select__options");
        if (!event.target.closest(".cc58-custom-select")) {
          optionsContainers?.forEach(function (optionsContainer) {
            optionsContainer.style.display = "none";
          });
        }
      });

      // Click on show more and less buttons
      live(".cc58-show-more-less--wrapper button", "click", function (event) {
        var dataType = this.dataset.type;
        var mainSlideWrapper = document.querySelector(".cc58-Product__Slideshow");

        if (dataType == "more") {
          mainSlideWrapper.classList.add("cc58-Product__SlideshowMore");
          this.parentElement.classList.add("cc58-show-more--active");
        } else if (dataType == "less") {
          mainSlideWrapper.classList.remove("cc58-Product__SlideshowMore");
          this.parentElement.classList.remove("cc58-show-more--active");
        }
      });

      // On variant change event
      window.addEventListener("GH:ChangeVariant", function (event) {
        var featured_media = event.detail;
        // Update second feature media image
        updateSecondFeatureImage(featured_media);
      });

      // Click on reviewoption
      live(".ProductMeta .product_reviews span, .ProductMeta .product_reviews img", "click", function (event) {
        document.getElementById("judgeme_product_reviews")?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      });
    }

    /* Variation Init */
    function init() {
      document.body.classList.add(variantion_class);

      // PDP color options
      addMaterialSelectorOnPDP();

      // Review section position change from bottom to top after Product Gallery section
      var heroSection = document.querySelector(".cc-product-main-section");
      var reviewWrapper = document.querySelector(".shopify-app-block #judgeme_product_reviews");
      if (heroSection && reviewWrapper) {
        var reviewSection = reviewWrapper.closest(".shopify-section");
        heroSection.insertAdjacentElement("afterend", reviewSection);
      }

      // Change Evergraving type content
      changeEvergravingType();

      // Change Product Gallery image position
      changeGalleryImagePosition();

      // Insert section
      customSelectOption();

      // Event handler
      eventHandlers();

      // Show first button
      waitForElement(".Product__InfoWrapper .product-custom-switcher  .coords-btn.active-switcher", function () {
        var textColorOption = document.querySelector(".Product__InfoWrapper .product-custom-switcher  .custom-switcher-btn.text-btn");
        textColorOption?.click();
      });

      // Change placeholder
      var morseText = document.querySelectorAll(
        ".Product__InfoWrapper .product-custom-switcher-box .custom-swicther-content input#morse, .Product__InfoWrapper .product-custom-switcher-box input#text-engrave"
      );
      if (morseText) {
        morseText.forEach(function (text) {
          text.setAttribute("placeholder", "Your text here");
        });
      }

      // Update label text
      changeContent(".Product__InfoWrapper .ProductForm__Variants .ProductForm__Option.productOption--size .ProductForm__Label", "SELECT SIZE:");
      changeContent(".Product__InfoWrapper .engrave-font-chooser-title", "SELECT Engraving Font:");
      changeContent(".coordinates-variant .engrave-font-chooser-wrapper .engrave-font-chooser-title", "SELECT Engraving Font:");

      // Add quote section
      waitForElement(".Product__Slideshow .flickity-viewport", addImageQuote);
    }

    /* Initialise variation */
    waitForElement(selectors.waitForElementSelector, init);

    // Click on gift button
    live(".ProductForm__Option--addons li", "click", function () {
      var classListEl = this.classList;
      var input = document.querySelector(".Product__Info  .gpo-container .show-addon-for-option input");
      var otherInputs = document.querySelectorAll(".ProductForm__Option--addons li");
      otherInputs.forEach(function (item) {
        item.classList.remove("cc58-product__addon--option2-box--active");
      });

      this.classList.add("cc58-product__addon--option2-box--active");

      if (!input) return;

      if (classListEl.contains("cc58-product__addon--option2-box") && input.checked) {
        input.click();
      } else if (classListEl.contains("cc58-product__addon--option1-box") && input.checked == false) {
        input.click();
      }
    });

    function getAddons() {
      var priceElm = document.querySelector(".Product__Info  .gpo-container .show-addon-for-option label .addOn");
      var price = "$13.00";
      if (priceElm) {
        price = priceElm.innerText.replaceAll("(", "").replaceAll(")", "");
      }

      return ` 
        <div class="ProductForm__Option ProductForm__Option--labelled ProductForm__Option--addons">
            <ul class="SizeSwatchList HorizontalList HorizontalList--spacingTight">
              <li class="HorizontalList__Item horizonatalListMain cc58-product__addon--option1-box">
                  <label class="option-template--product__main-1-0-addon" class="SizeSwatch cc58-product__addon--label">
                    <div class="cc58-product__addon--container  cc58-product__addon--option1">
                      <span class="cc58-product__addon">
                        <b>Premium gift box</b>
                        <span>${price}</span>
                      </span>
                    </div>
                  </label>
                </li>
              <li class="HorizontalList__Item horizonatalListMain cc58-product__addon--option2-box cc58-product__addon--option2-box--active">
                  <div class="option-template--product__main-1-0-addon" class="SizeSwatch cc58-product__addon--label">
                    <div class="cc58-product__addon--container  cc58-product__addon--option2">
                    <span class="cc58-product__addon">
                      <b>No premium gift box</b>
                    </span>
                    </div>
                  </div>
              </li>
              </ul>
        </div>`;
    }

    // Add gift box
    observeSelector(".Product__Info  .gpo-container .show-addon-for-option", function () {
      var option = document.querySelector(".Product__Info  .gpo-container .show-addon-for-option .gpo-ov-wrapper");
      var addon = getAddons();
      if (!document.querySelector(".ProductForm__Option--addons")) {
        option.insertAdjacentHTML("afterend", addon);
        option.classList.add("gpo-container-addon--hide");
      }
    });
  } catch (e) {
    if (debug) console.log(e, "error in Test" + variation_name);
  }
})();
